/**
 * Governance vote transaction handler using alphafi-sdk-js vote().
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getIcon } from './getIcon';
import { getSuiClient } from './client';
import { getTxErrorMessage } from './txResult';
import { createAlphaFiSDK, validateNetwork } from './networkUtils';
import { webSocketService } from '../services/websocket';
const EXPLORER_BASE_URL = 'https://suiscan.xyz';
export function voteTransactionHandler(params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { proposalObjectId, voteIndex, network, address, signAndExecuteTransaction, setNotificationInfo, setIsNotificationOpen, setIsTransactionLoading, voteOption, onVoteSuccess, } = params;
        const notify = (info) => {
            setNotificationInfo(info);
            setIsNotificationOpen(true);
        };
        const getExplorerLink = (digest) => digest
            ? `${EXPLORER_BASE_URL}/${network === 'testnet' ? 'testnet' : 'mainnet'}/tx/${digest}`
            : '';
        const validatedNetwork = validateNetwork(network);
        const sdk = createAlphaFiSDK(validatedNetwork);
        const suiClient = getSuiClient(validatedNetwork);
        notify({
            title: 'Awaiting Approval',
            description: 'Request wallet approval for your vote.',
            spinner: true,
        });
        setIsTransactionLoading(true);
        try {
            const tx = yield sdk.vote(voteIndex, proposalObjectId);
            if (!tx) {
                notify({
                    title: 'Voting Failed',
                    description: 'Failed to build vote transaction',
                    image: getIcon('failed'),
                });
                setIsTransactionLoading(false);
                return;
            }
            signAndExecuteTransaction({ transaction: tx }, {
                onSuccess: (result) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (result.success) {
                            notify({
                                title: 'Vote Submitted',
                                description: `Your vote (${voteOption}) has been successfully recorded.`,
                                image: getIcon('success'),
                                link: getExplorerLink(result.digest),
                            });
                            onVoteSuccess === null || onVoteSuccess === void 0 ? void 0 : onVoteSuccess();
                            webSocketService.sendVoteNotification(address, proposalObjectId);
                        }
                        else {
                            const txResult = yield suiClient
                                .waitForTransaction({ digest: result.digest, include: { effects: true } })
                                .catch(() => null);
                            notify({
                                title: 'Voting Failed',
                                description: (txResult && getTxErrorMessage(txResult)) || 'Transaction failed',
                                image: getIcon('failed'),
                                link: getExplorerLink(result.digest),
                            });
                        }
                    }
                    catch (_a) {
                        notify({
                            title: 'Voting Failed',
                            description: 'Failed to confirm transaction',
                            image: getIcon('failed'),
                            link: getExplorerLink(result.digest),
                        });
                    }
                    finally {
                        setIsTransactionLoading(false);
                    }
                }),
                onError: (error) => {
                    var _a, _b;
                    notify({
                        title: 'Voting Cancelled',
                        description: ((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('rejected'))
                            ? 'Transaction was cancelled by user'
                            : ((_b = error.message) !== null && _b !== void 0 ? _b : 'Transaction failed'),
                        image: getIcon('failed'),
                    });
                    setIsTransactionLoading(false);
                },
            });
        }
        catch (error) {
            notify({
                title: 'Voting Failed',
                description: (_a = error.message) !== null && _a !== void 0 ? _a : 'Failed to build vote transaction',
                image: getIcon('failed'),
            });
            setIsTransactionLoading(false);
        }
    });
}
